module.exports = __webpack_public_path__ + "media/images/soar/user_experience_pedro-17b3e3f4a95e5470c825580438f39181.png";